import { render, staticRenderFns } from "./icyBackhome.vue?vue&type=template&id=6d8ef8c4&scoped=true&"
import script from "./icyBackhome.vue?vue&type=script&lang=js&"
export * from "./icyBackhome.vue?vue&type=script&lang=js&"
import style0 from "./icyBackhome.vue?vue&type=style&index=0&id=6d8ef8c4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d8ef8c4",
  null
  
)

export default component.exports